export default __webpack_public_path__ + "static/media/kanban-icon.51c0a074.svg";